import React from 'react';
import ReportViewer from "./base/ReportViewer";

const RapportValeurInventaire = () => {

    return (
        <div style={{ height: "100%" }}>
            <ReportViewer reportName={"Rapportvaleurinventairereport"} />
        </div>
    );
}
export default RapportValeurInventaire;